import { type FC, type ReactNode, useMemo } from "react";
import { ActivityKeys } from "web_myplann/Api/Activities/ActivityKeys";
import { useIsNoAdvisorQuery } from "web_myplann/Api/Client/useClientQuery";
import { FinanceKeys } from "web_myplann/Api/Finances/financeKeys";
import { NotificationCenterKeys } from "web_myplann/Api/NotificationCenter/notificationCenterKeys";
import { useNotificationCenterRightOptional } from "web_myplann/Api/Rights/RightsProvider";
import { TaskKeys } from "web_myplann/Api/Tasks/TaskKeys";
import { DashboardTitleCard } from "web_myplann/Dashboard/Components/DashboardTitleCard";
import { MissingAdvisor } from "web_myplann/Profile/Components/MissingAdvisor";
import { MyPlannLayout } from "web_myplann/Shared/Header/MyPlannLayout";
import { useHideNavbar } from "web_myplann/Shared/Hooks/useHideNavbar";

type Props = {
	children: ReactNode;
	background?: string;
	showTopGlow?: boolean;
};

export const DashboardShell: FC<Props> = ({
	children,
	background,
	showTopGlow,
}) => {
	const { data: isNoAdvisor } = useIsNoAdvisorQuery();
	const hasNotificationCenterRight = useNotificationCenterRightOptional();

	const pullToRefreshQueryKeys = useMemo(
		() => [
			hasNotificationCenterRight
				? NotificationCenterKeys.all
				: TaskKeys.lists(),
			...(hasNotificationCenterRight ? [] : [ActivityKeys.lists()]),
			FinanceKeys.expense(),
			FinanceKeys.income(),
			FinanceKeys.reporting(),
		],
		[hasNotificationCenterRight],
	);

	useHideNavbar(isNoAdvisor === true);

	if (isNoAdvisor) {
		return (
			<MyPlannLayout disableContentPadding disableTopPadding>
				<MissingAdvisor />
			</MyPlannLayout>
		);
	}

	return (
		<MyPlannLayout
			disableContentPadding
			disableTopPadding
			bgColor={background}
			topGlow={showTopGlow}
		>
			<DashboardTitleCard
				pullToRefreshProps={{ queryKeys: pullToRefreshQueryKeys }}
			>
				{children}
			</DashboardTitleCard>
		</MyPlannLayout>
	);
};
